import { INTERCOM_APP_ID } from 'config/constants';
import { ContextProviders } from 'context/ContextProviders';
import { AuthProvider } from 'modules/auth/AuthContext';
import { handleAuthEvent } from 'modules/auth/services/authEventHandler';
import {
  loadValidUserFromStorage,
  saveUserToStorage,
} from 'modules/auth/services/authStorage';
import { useIsMobile } from 'modules/design-system';
import { SupportChatProvider } from 'modules/support-chat';
import { useTranslation } from 'react-i18next';
import { RouterWrapper } from './RouterWrapper';

// Strict mode is disabled for now due to the following issue:
// - tooltips are not working properly (they stay visible after the mouse leaves the element)
const App = function App() {
  const isMobile = useIsMobile();
  const { i18n } = useTranslation();

  const initialUser = loadValidUserFromStorage();

  return (
    <AuthProvider
      initialUser={initialUser}
      onAuthEvent={handleAuthEvent}
      onUserUpdate={(event) => {
        saveUserToStorage(event.user);
      }}
    >
      <ContextProviders>
        <SupportChatProvider
          appId={INTERCOM_APP_ID}
          hideLauncher={isMobile}
          language={i18n.resolvedLanguage}
        >
          {/* Dates come from moment's global locale, which React cannot
              observe: anything not re-rendering on `languageChanged` (AG Grid
              cells) needs this remount to leave the previous language. */}
          <RouterWrapper key={i18n.resolvedLanguage} />
        </SupportChatProvider>
      </ContextProviders>
    </AuthProvider>
  );
};

export default App;
